// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginEmailStep__content-ae2af0 {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.LoginEmailStep__form-ea1733 {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.LoginEmailStep__options-d7ca02 {
  width: 100%;
}

.LoginEmailStep__form-control-e09d68 {
  width: 100%;
  margin-bottom: 12px;
}

.LoginEmailStep__submit-a91d06 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/Login/LoginViews/LoginEmailStep/LoginEmailStep.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".content {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.form {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.options {\n  width: 100%;\n}\n\n.form-control {\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.submit {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `LoginEmailStep__content-ae2af0`,
	"form": `LoginEmailStep__form-ea1733`,
	"options": `LoginEmailStep__options-d7ca02`,
	"form-control": `LoginEmailStep__form-control-e09d68`,
	"formControl": `LoginEmailStep__form-control-e09d68`,
	"submit": `LoginEmailStep__submit-a91d06`
};
module.exports = ___CSS_LOADER_EXPORT___;
